import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { LoaderCircular } from '../../index';
import * as Icons from '../Icon';

const noop = () => {};

const Button = ({
  isDisabled = false,
  isFullWidth,
  icon,
  iconColor,
  iconSize,
  iconStyle = {},
  isReverse,
  label,
  isMini,
  onClick,
  version,
  type,
  isLoading,
  className = '',
  style = {}
}) => {
  const componentName = `Icon${icon}`;
  const IconComponent = icon && Icons[componentName];

  if (icon && !IconComponent) {
    console.error("Icon couldn't be found:", icon);
  }

  return /*#__PURE__*/React.createElement("button", {
    className: classnames(`btn btn--${version}`, className, {
      'btn--reverse': isReverse,
      'btn--block': isFullWidth,
      'btn--mini': isMini,
      'btn--no-label': !label || label && label.length && label.length === 0
    }),
    style: style,
    onClick: onClick || noop,
    disabled: isDisabled || isLoading,
    type: type
  }, label && label, isLoading ? /*#__PURE__*/React.createElement(LoaderCircular, {
    style: {
      padding: '0px 7px 7px 5px',
      width: 'auto'
    },
    size: 9,
    thickness: 1,
    color: "text-secondary",
    className: "loader"
  }) : icon && /*#__PURE__*/React.createElement(IconComponent, {
    color: iconColor && iconColor,
    size: iconSize,
    style: iconStyle
  }));
};

Button.propTypes = {
  version: PropTypes.oneOf(['primary', 'secondary', 'monochrome', 'success', 'error', 'danger', 'warning', 'outline', 'text']).isRequired,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.number,
  iconStyle: PropTypes.object,
  isDisabled: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMini: PropTypes.bool,
  isReverse: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default Button;